import fetchInvestments from './InvestmentsHelper';
import { fetchFunds } from './FundsHelper';
import { fetchPortcos } from './PortfolioCompaniesHelper'; 
import { fetchFundsWithInvestments } from './PortfolioCompaniesHelper';
import { GetAffinityList } from '../api/AffinityAPIHelper'; 


export const fetchDashboardMetrics = async (fundId = null) => {
    try {
        const investmentData = await fetchInvestments();
        const filteredInvestmentData = fundId !== null
            ? investmentData.filter(investment => investment.fundId === fundId)
            : investmentData;
        const fundIds = new Set();
        const portfolioCompanies = new Set();
        let currentAumByFund = {};
        let totalInvestedCapital = 0;
        let investmentStatsByFund = {};

        filteredInvestmentData.forEach(investment => {
            fundIds.add(investment.fundId);
            portfolioCompanies.add(investment.portcoName);

            // Only assign the currentAum to the fund if it hasn't been assigned yet
            if (!currentAumByFund.hasOwnProperty(investment.fundId)) {
                currentAumByFund[investment.fundId] = Number(investment.currentAum);
                investmentStatsByFund[investment.fundId] = {
                    fundId: investment.fundId,
                    fundName: investment.fundName,
                    investments: []
                };
            }

            investmentStatsByFund[investment.fundId].investments.push(Number(investment.investmentAmount));

            totalInvestedCapital += Number(investment.investmentAmount);
        });

        let currentAumTotal = Object.values(currentAumByFund).reduce((a, b) => a + b, 0);
        let totalAvailableToInvest = currentAumTotal - totalInvestedCapital;

        let aggregatedStatsByFund = Object.values(investmentStatsByFund).map(fund => ({
            fundId: fund.fundId,
            fundName: fund.fundName,
            averageInvestment: fund.investments.reduce((a, b) => a + b, 0) / fund.investments.length,
            minInvestment: Math.min(...fund.investments),
            maxInvestment: Math.max(...fund.investments)
        }));

        return {
            metrics: {
                numberOfFunds: fundIds.size,
                numberOfPortfolioCompanies: portfolioCompanies.size,
                currentAUM: currentAumTotal,
                totalInvestedCapital: totalInvestedCapital,
                totalAvailableToInvest: totalAvailableToInvest
            },
            fundStats: aggregatedStatsByFund,
            investmentData: filteredInvestmentData
        };
    } catch (error) {
        console.error('Error fetching data: ', error);
        return null;
    }
}



export const getFunds = async (fundId = null) => {
    try {
        const funds = await fetchFunds();
        const filteredFunds = fundId !== null
            ? funds.filter(fund => fund.internal_fund_id === fundId)
            : funds;
        return filteredFunds;
    } catch (error) {
        console.error('Error fetching funds: ', error);
        return null;
    }
}


export const helpGetAffinityList = async (listId = null) => {
    try {
        const affinityList = await GetAffinityList(listId);
        return affinityList;
    } catch (error) {
        console.error('Error fetching affinityList: ', error);
        return null;
    }
}

export const getPortfolioCompanies = async () => {
    try {
        const portfolioCompanies = await fetchPortcos();
        return portfolioCompanies;
    } catch (error) {
        console.error('Error fetching portfolio companies: ', error);
        return null;
    }
}

export const getFundsWithInvestments = async () => {
    try {
        const fundsWithInvestments = await fetchFundsWithInvestments();
        return fundsWithInvestments;
    } catch (error) {
        console.error('Error fetching funds with investments: ', error);
        return null;
    }
}

export default {
    fetchDashboardMetrics,
    getFunds,
    getPortfolioCompanies,
    getFundsWithInvestments,
    helpGetAffinityList,
}

